import { useStore } from "../index";

export const useGroupMember = () => useStore(({ groupMember }) => groupMember);
